import {
  CancelVerificationCodeResponse,
  CancelVerificationCodeResponseRequestPayload,
  RetryVerificationCodeResponse,
  RetryVerificationCodeResponseRequestPayload,
  SendVerificationCodeRequestPayload,
  SendVerificationCodeResponse,
  UpdatePhoneNumberRequestPayload,
  VerifyCodeRequestPayload,
  VerifyCodeResponse,
} from "~/common/types/verificationCode";
import { api } from "~/providers/api/axios";

export const sendVerificationCode = async (
  payload: SendVerificationCodeRequestPayload,
) => {
  const { data } = await api.post<SendVerificationCodeResponse>(
    `/v1/verification/send`,
    payload,
  );
  return data;
};

export const verifyCode = async (payload: VerifyCodeRequestPayload) => {
  const { data } = await api.post<VerifyCodeResponse>(
    `/v1/verification/verify`,
    payload,
  );
  return data;
};

export const retryVerificationCode = async (
  payload: RetryVerificationCodeResponseRequestPayload,
) => {
  const { data } = await api.post<RetryVerificationCodeResponse>(
    `/v1/verification/retry`,
    payload,
  );
  return data;
};

export const cancelVerificationCode = async (
  payload: CancelVerificationCodeResponseRequestPayload,
) => {
  const { data } = await api.post<CancelVerificationCodeResponse>(
    `/v1/verification/cancel`,
    payload,
  );
  return data;
};

export const updatePhoneNumber = async ({
  user_id,
  verification_token,
  phone_number,
}: UpdatePhoneNumberRequestPayload) => {
  const { data } = await api.put<string>(`/v1/team-members/${user_id}/phone`, {
    verification_token,
    phone_number,
  });

  return data;
};
